<template>
    <!-- eslint-disable max-len -->
    <div>
        <section
            class="block iframe-container mb-2"
            :style="{ height: iframeData.iFrameHeight + 'px' }"
        >
            <iframe
                :src="iframeData.iFrame"
                :title="title"
                frameborder="0"
            ></iframe>
        </section>
        <div v-if="iframeData.videos" class="container-fluid">
            <div class="row">
                <div
                    v-for="(video, index) in iframeData.videos"
                    :key="index"
                    class="col-12 col-lg mb-2 mb-lg-0 video-col"
                >
                    <div class="video-container">
                        <iframe :src="video.videoEmbedUrl" frameborder="0">
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        iframeData: {
            type: Object,
            default() {
                return {};
            }
        },
        title: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
.iframe-container {
    overflow: hidden;
    position: relative;
    margin-top: 130px;
}

.iframe-container iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    overflow: hidden;
}

.video-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
}

.video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.video-col:only-child {
    @include media-breakpoint-up(lg) {
        max-width: 70%;
        margin: 0 auto;
    }
}
</style>
